
import { useState } from 'react';
import Table from './Table';
import Checkbox from '../../../../Core/Fields/Floating/Checkbox';
const Tab2 = ({ setSelectedCompanyAccounts, isyca, setyca , doctype="",idData=""}) => {
    const [isGroup, setIsGroup] = useState(0)
    return (
           <div>
            <div className="px-3" style={{ background: 'white' }}>
              
                <div className="mb-3" >

                    <div className="col-md-12 px-2" style={{ display: 'flex', gap: '20px' }} >
                        <div className='' style={{ height: "100%", borderRadius: '4px', display: 'flex', flexDirection: 'column', width: '100%', padding: '10px', border: '1px solid #DBDBDB', borderRadius: '5px' }}>
                            <div style={{ display: 'flex', gap: '15px' }}>
                                <div style={{ flex: 1 }}>
                                    <p className='' style={{ fontSize: '16px', fontWeight: '600' }}>Reference</p>
                                </div>
                            </div>
 <div className="mb-1" style={{ display: 'flex', gap: '15px' }}>
                               <div style={{ flex: 1 }}>
  <Checkbox
    id="IsYourCompanyAddress"
    label="Is Your Company Address"
    checked={isyca === 1}
    onChange={(checked) => setyca(checked ? 1 : 0)}
  />
</div>

                                </div>
                          <Table
                    setSelectedCompanyAccounts={setSelectedCompanyAccounts}
                    doktype={doctype}
                    idData={idData}
                />





                        </div>
                    </div>

                </div>
            
            </div>

        </div >
    )
}

export default Tab2